import { openHealthLeeMiniApp } from './healthLee';

const externalQuestHandlers: Record<string, (deepLink?: string | null) => void> = {
    healthlee: openHealthLeeMiniApp,
};

export const openExternalQuest = (external?: string | null, deepLink?: string | null) => {
    if (!external) return;
    externalQuestHandlers[external]?.(deepLink);
};
